<template>
  <div>
    <div class="product4">
      <div class="productBanner">
        <div class="module">
          <div class="h1">ZTMapVR</div>
          <div class="line"></div>
          <div class="h2">VR全景三维可视化平台</div>
          <div class="p">行业领先的创新实景VR引擎实现三维模型构建、沉浸式渲染</div>
        </div>
        <div class="img"></div>
      </div>
      <div class="overview">
        <div class="module">
          <div class="productTitle">
            概述
            <span>/Overview</span>
          </div>
          <div
            class="p"
          >臻图ZTMapVR平台是一个基于实景照片实现快速三维建模的软件产品，其主要目的是为了实现智能化快速三维建模。基于“ZTMapVR”平台可以快速实现大部分场景下的高保真建模，并提供快速场景发布能力。提供强大的沉浸式渲染和交互开发能力，并可结合GIS、BIM等空间可视化技术和产品，实现空间分析能力。可以广泛应用于GIS、BIM、VR/AR、物联网、互联网等智慧城市各领域。</div>
        </div>
      </div>
      <div class="function">
        <div class="productTitle">
          功能简介
          <span>/Function</span>
        </div>
        <div class="box">
          <div class="module">
            <div class="point">
              <div class="title">自动建模</div>
              <div class="p">从图片到模型的转变</div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="title">三维渲染</div>
              <div class="p">从模型到可视化发布</div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="title">沉浸漫游</div>
              <div class="p">VR、AR沉浸式体验</div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">空间量测</div>
              <div class="p">基于真三维的空间量测</div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">空间分析</div>
              <div class="p">结合GIS/BIM进行空间分析</div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">扩展集成</div>
              <div class="p">深度定制扩展开发和集成</div>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="module">
          <div class="productTitle">
            效果图
            <span>/Rendering</span>
          </div>
          <div class="list">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="function hb">
        <div class="productTitle">
          行业应用
          <span>/Application</span>
        </div>
        <div class="box">
          <div class="module">
            <div class="point">
              <div class="title">公共安全</div>
              <div class="p">更高效地掌握实地三维特证，辅助决策</div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="title">物联网</div>
              <div class="p">结合GIS、BIM等技术，深度可视化作用</div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="title">智慧城市……</div>
              <div class="p"></div>
              <div class="y">
                <div></div>
              </div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">地产家居</div>
              <div class="p">更高效、逼真地展示产品</div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">电子商务</div>
              <div class="p">高效建模、沉浸式体验购物</div>
            </div>
            <div class="point">
              <div class="y">
                <div></div>
              </div>
              <div class="title">VR/AR</div>
              <div class="p">为现实VS虚拟的深度融合提供更有效的手段</div>
            </div>
          </div>
        </div>
      </div>
      <div class="characteristics">
        <div class="module">
          <div class="productTitle">
            技术特点
            <span>/Characteristics</span>
          </div>
          <div class="list">
            <div>
              <div class="title">建模速度快</div>
              <div class="p">比传统建模节省95%以上时间</div>
            </div>
            <div>
              <div class="title">需要素材少</div>
              <div class="p">只需要照片，无需平面图结构图</div>
            </div>
            <div>
              <div class="title">完全还原真实场景</div>
              <div class="p">实景照片纹理贴图，真实还原实际场景</div>
            </div>
            <div>
              <div class="title">答复节省建设成本</div>
              <div class="p">人工成本大幅下降</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-product4">
      <div class="product-title">
        <div class="title-content">
          <div class="title">ZTMapVR</div>
          <div class="line"></div>
          <div class="p">
            VR全景三维可视化平台
          </div>
          <div class="span">
            行业领先的创新实景VR引擎实现三维模型构建、沉浸式渲染
          </div>
        </div>
        <div class="img">
          <img src="../../assets/images/index/banner_img4.png" alt="">
        </div>
      </div>
      <div class="part">
        <div class="part-title">概述</div>
        <div class="en-title">OVERVIEW</div>
        <div class="overview-content">
          臻图ZTMapVR平台是一个基于实景照片实现快速三维建模的软件产品，其主要目的是为了实现智能化快速三维建模。基于“ZTMapVR”平台可以快速实现大部分场景下的高保真建模，并提供快速场景发布能力。提供强大的沉浸式渲染和交互开发能力，并可结合GIS、BIM等空间可视化技术和产品，实现空间分析能力。可以广泛应用于GIS、BIM、VR/AR、物联网、互联网等智慧城市各领域。
        </div>
      </div>
      <div class="part function">
        <div class="part-title">功能简介</div>
        <div class="en-title">FUNCTION</div>
        <div class="content">
          <div class="item" v-for="item in functionList" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="part-title">效果图</div>
        <div class="en-title">RENDERING</div>
        <div class="swiper">
          <el-carousel class="case-carousel" indicator-position="outside" height="23rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`product4-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="part function" :style="backgroundStyle">
        <div class="part-title">行业应用</div>
        <div class="en-title">APPLICATION</div>
        <div class="content">
          <div class="item" v-for="item in application" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="part jishu">
        <div class="part-title">技术特点</div>
        <div class="en-title">CHARACTERISTICS</div>
        <div class="list">
          <div class="part" style="background-color: #f895a4;">
            <p>建模速度快</p>
            <span>比传统建模节省95%以上时间</span>
          </div>
          <div class="part" style="background-color: #a8efa3;">
            <p>需要素材少</p>
            <span>只需要照片，无需平面图结构图</span>
          </div>
          <div class="part" style="background-color: #ffd28e;">
            <p>完全还原真实场景</p>
            <span>实景照片纹理贴图，真实还原实际场景</span>
          </div>
          <div class="part" style="background-color: #70b4ff;">
            <p>答复节省建设成本</p>
            <span>人工成本大幅下降</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Product4",
  metaInfo: {
    title:
      "VR全景三维可视化平台_三维虚拟现实_VR深度建模_三维全景_ZTMapVR-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "VR全景,三维全景,VR建模,深度映射,沉浸式体验"
      },
      {
        name: "description",
        content:
          "ZTMapVR全景三维可视化平台是一个基于三维实景照片实现快速三维建模的软件产品,实现了智能化快速三维建模。基于ZTMapVR平台可以实现室内外场景下的高保真快速建模,并提供快速VR场景发布能力。"
      }
    ]
  },
  data() {
    return {
      functionList: [
        {
          id: 1,
          title: '空间量测',
          content: '基于真三维的空间量测'
        },
        {
          id: 2,
          title: '自动建模',
          content: '从图片到模型的转变'
        },
        {
          id: 3,
          title: '空间分析',
          content: '结合GIS/BIM进行空间分析'
        },
        {
          id: 4,
          title: '三维渲染',
          content: '从模型到可视化发布'
        },
        {
          id: 5,
          title: '扩展集成',
          content: '深度定制扩展开发和集成'
        },
        {
          id: 6,
          title: '沉浸漫游',
          content: 'VR、AR沉浸式体验'
        },
      ],
      application: [
        {
          id: 1,
          title: '地产家居',
          content: '更高效、逼真地展示产品'
        },
        {
          id: 2,
          title: '公共安全',
          content: '更高效地掌握实地三维特证，辅助决策'
        },
        {
          id: 3,
          title: '电子商务',
          content: '高效建模、沉浸式体验购物'
        },
        {
          id: 4,
          title: '物联网',
          content: '结合GIS、BIM等技术，深度可视化作用'
        },
        {
          id: 5,
          title: 'VR/AR',
          content: '为现实VS虚拟的深度融合提供更有效的手段'
        },
        {
          id: 6,
          title: '智慧城市……',
          content: ''
        },
      ],
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/product/${fileName}`);
    }
  },
  computed: {
    backgroundStyle() {
      return {
        background: `url(${this.getImg('bg1.png')})`
      };
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.productBanner {
  .img {
    background-image: url("../../assets/images/index/banner_img4.png");
  }
}
.product4 {
  .function {
    .productTitle {
      text-align: center;
      margin: 100px 0 60px 0;
    }
    .box {
      height: 325px;
      background: url("../../assets/images/product/timelinered.png") no-repeat
        center top / 100% auto;
      background-position-y: 78px;
      .module {
        height: 100%;
        position: relative;
      }
      .point {
        text-align: center;
        display: inline-block;
        position: absolute;
        &:nth-child(1) {
          top: 9px;
          left: 233px;
        }
        &:nth-child(2) {
          top: 16px;
          right: 347px;
        }
        &:nth-child(3) {
          top: 120px;
          right: -90px;
        }
        &:nth-child(4) {
          bottom: 37px;
          left: -82px;
        }
        &:nth-child(5) {
          bottom: 96px;
          right: 569px;
        }
        &:nth-child(6) {
          top: 175px;
          right: 148px;
        }
        .title {
          font-size: 24px;
          color: rgba(75, 75, 75, 1);
        }
        .p {
          font-size: 20px;
          color: rgba(124, 124, 124, 1);
          line-height: 28px;
        }
        .y {
          width: 40px;
          height: 40px;
          background: rgba(2, 118, 247, 0.22);
          border-radius: 50%;
          display: flex;
          justify-content: center; // 水平居中
          align-items: center; // 垂直居中
          margin: 20px auto;
          > div {
            width: 15px;
            height: 15px;
            background: rgba(2, 118, 247, 0.7);
            border-radius: 50%;
          }
        }
      }
    }
  }
  .rendering {
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 100px;
    }
    .list {
      font-size: 0;
      margin-bottom: 130px;
      > div {
        display: inline-block;
        width: 584px;
        height: 383px;
        background: #ccc;
        margin-bottom: 20px;
        &:nth-child(2n + 1) {
          margin-right: 20px;
        }
        background: no-repeat center center / 100% 100%;
        &:nth-child(1) {
          background-image: url("../../assets/images/product/product4-1.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/product/product4-2.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/product/product4-3.jpg");
        }
        &:nth-child(4) {
          background-image: url("../../assets/images/product/product4-4.jpg");
        }
      }
    }
  }
  .characteristics {
    background: none;
    height: auto;
    margin-top: 100px;
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 0;
    }
    .list {
      > div {
        width: 267px;
        height: 327px;
        border-radius: 5px;
        margin-right: 40px;
        margin-top: 60px;
        margin-bottom: 150px;
        padding: 0 27px;
        .title {
          font-size: 24px;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          margin: 80px 0 30px 0;
        }
        .p {
          font-size: 20px;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          text-align: center;
        }
        &:nth-child(1) {
          background: #f895a4;
        }
        &:nth-child(2) {
          background: #a8efa3;
        }
        &:nth-child(3) {
          background: #ffd28e;
        }
        &:nth-child(4) {
          background: #70b4ff;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .hb {
    .box {
      background: url("../../assets/images/product/timelinered.png") no-repeat
        center top / 100% auto;
      background-position-y: 78px;
    }
    .point {
      &:nth-child(1) {
        left: 101px !important;
      }
    }
  }
}
.mobile-product4 {
  display: none;
  flex-direction: column;
  font-family: 'Normal';
  .product-title {
    width: 100%;
    height: 28rem;
    background: linear-gradient(180deg, #3374EF 0%, #9DCFFF 100%);
    box-sizing: border-box;
    padding: 8rem 0 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: white;
    .title-content {
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .line {
        width: 4rem;
        height: 0.2rem;
        background: #FFFFFF;
        margin-top: 1rem;
      }
      .p {
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 2rem;
      }
      .span {
        width: 15rem;
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.6rem;
      }
    }
    .img {
      flex-grow: 1;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .overview-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .overview-content {
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      color: #3D3D3D;
      text-align: left;
      text-indent: 2em;
      margin-top: 2rem;
      color: #333333;
    }
  }
  .function {
    background-image: url('../../assets/images/product/timelinered.png');
    background-position: 5%;
    background-repeat: no-repeat;
    background-size: cover;
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item {
        width: 47.5%;
        box-sizing: border-box;
        padding: 2rem 1.5rem 1.5rem 1.5rem;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'Normal';
        margin-top: 1.5rem;
        text-align: left;
        >p {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
          color: #333333;
          
        }
      }
    }
  }
  .rendering {
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem 0;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .swiper {
      margin-top: 2rem;
    }
  }
  .characteristics {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem;
    height: 25rem;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding-top: 2rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          width: 50%;
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 1rem;
            font-size: 1rem;
            font-weight: 350;
            color: #333333;
          }
        }
      }
    }
  }
  .jishu {
    width: 100%;
    .list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 1rem;
      .part {
        width: 45%;
        margin-top: 2rem;
        border-radius: 5px;
        color: white;
        height: 15rem;
        >p {
          font-size: 1.3rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
        }
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .productBanner {
    display: none !important;
  }
  .product4 {
    display: none;
  }
  .mobile-product4 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/Product4.vue